import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Briefcase } from "lucide-react";

const CorporateCharter = () => {
  const serviceData = {
    serviceName: "Corporate Charter",
    heroImage: require("../../assets/Legacy-650-ext-JS.jpg"),
    heroTagline: "Business Aviation Excellence",
    heroDescription:
      "Elevate your business travel with our corporate helicopter charter services. Save time, boost productivity, and impress clients with HighKraft Aviation.",
    overviewTitle: "Corporate Helicopter Charter Solutions",
    overviewText: `HighKraft Aviation provides premium corporate helicopter charter services tailored for businesses that value time, efficiency, and professionalism. Our corporate solutions are designed to help executives and teams travel smarter, not harder.

In today's fast-paced business environment, time is your most valuable asset. Our corporate charter service eliminates the hassles of commercial aviation – no long security lines, no flight delays, and no wasted hours in traffic. Travel directly from point A to point B, maximizing your productive hours.

Whether you need to attend multiple meetings across different cities in a single day, transport your executive team for an important presentation, or provide VIP treatment to visiting clients, our corporate charter service delivers reliability and prestige.`,
    useCases: [
      {
        title: "Executive Travel",
        description:
          "Swift and comfortable travel for C-suite executives between offices, meetings, and conferences.",
      },
      {
        title: "Multi-City Meetings",
        description:
          "Cover multiple cities in a single day for meetings, inspections, or site visits.",
      },
      {
        title: "Client Transportation",
        description:
          "Impress important clients with premium helicopter transfers and aerial tours.",
      },
      {
        title: "Team Transport",
        description:
          "Efficient group transportation for corporate teams attending events or off-sites.",
      },
      {
        title: "Project Site Visits",
        description:
          "Quick access to remote project sites, factories, or construction locations.",
      },
      {
        title: "Investor Relations",
        description:
          "Provide investors and board members with exclusive transportation experiences.",
      },
    ],
    safetyFeatures: [
      {
        title: "Experienced Corporate Pilots",
        description:
          "Pilots with extensive corporate flight experience and professional demeanor.",
      },
      {
        title: "Modern Fleet",
        description:
          "State-of-the-art helicopters with advanced avionics and safety systems.",
      },
      {
        title: "Business Insurance",
        description:
          "Comprehensive corporate travel insurance for all passengers.",
      },
      {
        title: "Flexible Scheduling",
        description:
          "Flights scheduled around your business needs with on-time guarantee.",
      },
      {
        title: "Confidential Service",
        description:
          "Discrete service ensuring business discussions remain private.",
      },
      {
        title: "Account Management",
        description:
          "Dedicated account managers for corporate clients with regular travel needs.",
      },
    ],
    galleryImages: [
      "https://images.pexels.com/photos/2868226/pexels-photo-2868226.jpeg",
      "https://images.pexels.com/photos/3834331/pexels-photo-3834331.jpeg",
      "https://images.pexels.com/photos/104757/pexels-photo-104757.jpeg",
    ],
    faqs: [
      {
        question: "Do you offer corporate accounts for regular travel?",
        answer:
          "Yes, we offer corporate accounts with preferential rates, dedicated account management, and streamlined booking processes for companies with regular travel needs.",
      },
      {
        question: "Can meetings be conducted during the flight?",
        answer:
          "Our corporate helicopters provide a quiet cabin environment suitable for discussions. We also offer configurations with facing seats for easier conversation.",
      },
      {
        question: "What is the passenger capacity for corporate charters?",
        answer:
          "Our corporate fleet can accommodate 2-7 passengers depending on the helicopter model. We can recommend the best aircraft for your team size.",
      },
      {
        question: "Can you arrange ground transportation at the destination?",
        answer:
          "Absolutely! We can coordinate premium ground transportation at both departure and arrival points for a seamless travel experience.",
      },
      {
        question: "How do you ensure schedule reliability?",
        answer:
          "We maintain backup aircraft and crew to handle any unforeseen circumstances. Our operations team monitors flights in real-time to ensure on-time departures.",
      },
    ],
    icon: Briefcase,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default CorporateCharter;
